module.exports = __webpack_public_path__ + "static/img/组 2851.ec6181e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2851.png
// module id = QNm7
// module chunks = 0